<template>
  <div>
    <div class="grid grid-cols-1 lg:hidden w-full">
      <select
        v-model="option"
        aria-label="Select a status" class="form-select col-start-1 row-start-1 w-full appearance-none"
        @change="toggleStatus(option)"
      >
        <option v-for="itm in options" :key="itm.value" :value="itm.value" :selected="itm.value === type">
          {{ itm.name }}
        </option>
      </select>
    </div>
    <div class="hidden lg:block">
      <div class="flex items-center justify-center md:justify-start gap-x-1">
        <div v-for="itm in options" :key="itm.value">
          <button @click="toggleStatus(itm.value)" class="btn-primary bg-gray-400" :class="{'bg-blue-600': type === itm.value}">
            {{ itm.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliveryTypeToggle',

  props: {
    type: String,
    options: {
      type: Array,
      default: () => [
        {
          name: 'To be Delivered',
          value: 'delivery'
        },
        {
          name: 'Collection by Customer',
          value: 'collection'
        },
      ]
    }
  },

  data() {
    return {
      option: this.type || 'collection',
    }
  },
  methods: {
    toggleStatus(status) {
      this.$emit('toggle', status);
    }
  }
}
</script>
